import { post } from 'api/base';
import { Corti } from '@corti/sdk';
import { QueryClient } from '@tanstack/react-query';

const cortiKey = ['cortiToken'] as const;
const staleTime = 1000 * 60 * 4;
const gcTime = 1000 * 60 * 10;
const retries = 3;

// Non-hook helper for places where hooks cannot be used (e.g., refreshAccessToken)
export function fetchCortiToken(queryClient: QueryClient) {
  return queryClient.fetchQuery({
    queryKey: cortiKey,
    queryFn: () => post('cortiToken') as Promise<Corti.AuthTokenResponse>,
    retry: retries,
    staleTime: staleTime,
    gcTime: gcTime,
  });
}
